{
  "linkTo": "Définir l'emplacement",
  "locationNotPinned": "Emplacement non épinglé",
  "locationPinned": "Emplacement épinglé",
  "locationPinnedExplanation": "« Localisation épinglée » signifie que la localisation de l'appareil a été définie manuellement et sera utilisée à la place de la localisation GPS.",
  "locationUnpinnedExplanation": "« Location Unpinned » signifie que l'emplacement de l'appareil est déterminé par la puce GPS.",
  "pinnedLocation": "Emplacement épinglé",
  "pinningExplanation": "L'identification de l'emplacement de l'appareil remplacera la lecture actuelle de la puce GPS. Vous pouvez effectuer cette opération si votre appareil a une réception GPS constamment médiocre, par exemple une pompe installée à l'intérieur d'un entrepôt avec un toit en métal.",
  "tapTheMapToSetLocation": "Appuyez sur la carte pour définir un emplacement permanent",
  "title": "Emplacement du périphérique de broche",
  "unpinButton": "Clair"
}
